import { FieldOverride } from '@/bpc/types/FieldOverride';
export const FIELD_OVERRIDES = {
    'business_information.is_registered': FieldOverride.YesNo,
    'business_information.subject_to_vat': FieldOverride.YesNo,
    'business_information.should_auto_capture_orders': FieldOverride.YesNo,
    'in_stores.business_concepts': FieldOverride.BusinessConcepts,
    'business_information.product_channel': FieldOverride.BusinessConcepts,
    sensitive_goods: FieldOverride.BusinessConcepts,
    business_size: FieldOverride.BusinessSizeComponent,
};
